// boxtypes that can be used when defining a box
// the boxtype defines the layout of the box (rendering template) and the elements that can be used to build it
// e.g. valueTable can be used to build a box with a table layout
var BoxTypes = ['generic', 'listBox', 'infoBox', 'textLine' // 'graph.pie',
// 'graph.radial',
// 'graph.circle',
// ..add more box types/rendering templates here
]; // element types (element templates) that can be used to define elements in a box

var ElementTypes = ['icon', 'text', 'title', 'value', 'infoChip', 'infoChipWithText', 'progressBar', 'percentage', 'label', 'svg', 'image', 'graph.pie', 'graph.radial', 'graph.circle', 'apexChart' // ..add more element types here
]; // param keys that can be used when defining an element
// the element params define the properties of the element
// e.g. the type of icon, the value of the text, classNames, etc.

var ElementParams = ['type', 'itemKey', 'value', 'getValue', 'className', 'getClassName', 'prefix', 'postfix', 'children', 'getChildren', 'label', 'icon', 'percentage']; // layout positions that can be used when defining a box
// the position defines where the element is rendered in the box, or in the case of a table,
// where the element is rendered in the table row

var PositionNames = ['top', 'bottom', 'left', 'right', 'center'];
export { BoxTypes, ElementParams, ElementTypes, PositionNames };